import React, { useEffect, useState } from "react";
import {
  Box,
  DialogContent,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"; // Document icon
import { WhatsappTemplatesAPI } from "../../../../../../api/Endpoints/WhatsappTemplateAPI";
import { toast } from "react-toastify";

function PreViewer({
  file,
  setFile,
  setPreviewrOpen,
  id,
  fetchWhatsappMessages,
  phone_number,
}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  let fileURL = null;

  const handleClose = () => {
    if (file) {
      URL.revokeObjectURL(file);
    }
    setFile(null);
    setOpen(false);
    setPreviewrOpen(false);
  };

  useEffect(() => {
    if (file) {
      setOpen(true);
    }
  }, [file]);

  if (!file || !file.type) return null;

  const isImage = file.type.startsWith("image");
  const isVideo = file.type.startsWith("video");
  const isDocument = file.type.startsWith("application"); // Detect documents

  fileURL = URL.createObjectURL(file);

  const handleFileSent = async () => {
    const isVideo = file.type.startsWith("video");
    setLoading(true);
    const formData = new FormData();
    formData.append(
      `${isVideo ? "video" : isDocument ? "document" : "image"}`,
      file
    );
    formData.append("to", phone_number);
    formData.append("lead_id", id);
    formData.append(
      "msg_type",
      isVideo ? "Video" : isDocument ? "Document" : "Image"
    );

    try {
      const res = await WhatsappTemplatesAPI.sentMessage(formData);
      if (res?.data.success) {
        const noLoad = true;
        fetchWhatsappMessages(noLoad);
        setTimeout(() => {
          setPreviewrOpen(false);
          setFile(null);
          setLoading(false);
        }, 1000);
      }  
    } catch (error) {
      console.log("err",error);
      toast.error(error?.data?.message, { autoClose: 2000 });
      setLoading(false);
    }
  };

  return (
    <div>
      {open && (
        <Box
          className="quick-send-block"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            position: "relative",
            background: "#fff",
            borderRadius: 8,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "12px 16px",
              borderTop: "1px solid #E8ECF4",
              backgroundColor: "#F9F9F9",
            }}
          >
            <IconButton
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "white",
                background: "rgba(0,0,0,0.5)",
              }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <DialogContent
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isImage ? (
              <img
                src={fileURL}
                alt="Full Preview"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  maxHeight: "90vh",
                  borderRadius: 8,
                  objectFit: "contain",
                }}
              />
            ) : isVideo ? (
              <video
                src={fileURL}
                controls
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  maxHeight: "90vh",
                  borderRadius: 8,
                }}
              />
            ) : isDocument ? (
              <Box sx={{ textAlign: "center" }}>
                <InsertDriveFileIcon sx={{ fontSize: 80, color: "#555" }} />
                <Box
                  sx={{
                    marginTop: 1,
                    fontSize: 14,
                    fontWeight: 500,
                    maxWidth: "100%",
                  }}
                >
                  {file.name}
                </Box>
              </Box>
            ) : null}
          </DialogContent>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "12px 16px",
              borderTop: "1px solid #E8ECF4",
              backgroundColor: "#F9F9F9",
            }}
          >
            <IconButton onClick={handleFileSent} disabled={loading}>
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                <SendIcon />
              )}
            </IconButton>
          </Box>
        </Box>
      )}
    </div>
  );
}

export default PreViewer;
